import React from "react";

export default function MonoSpace({ item }) {
  return <div className="mb-1" dangerouslySetInnerHTML={{ __html: item.monoSpaceHtml }} />;
}
